<!-- UtilitiesView.vue -->

<template>
  <div class="section coredeck-page-section">
    <div class="row">
      <div class="col s12">
        <div class="card">
          <!-- Header -->
          <div class="card-content blue-grey darken-4 white-text">
            <div class="row" style="margin-bottom: 0">
              <div class="col s12 m7">
                <span class="card-title"> Utilities </span>

                <div class="white-text" style="opacity: 0.85; font-size: 13px">
                  Submit today’s readings. Only the fields you provide will be written (no
                  zero/null overwrites).
                </div>

                <div
                  class="white-text"
                  style="opacity: 0.75; font-size: 12px; margin-top: 4px"
                >
                  Venue:
                  <strong>
                    {{ venueNameDisplay }}
                  </strong>
                </div>
              </div>

              <div class="col s12 m5 right-align" style="margin-top: 6px">
                <button
                  class="btn-small blue-grey lighten-1"
                  @click="clearForm"
                  :disabled="busy"
                >
                  Clear form
                </button>
              </div>
            </div>
          </div>

          <div class="card-content">
            <div class="row" style="margin-bottom: 0">
              <div class="input-field col s12 m4">
                <input
                  id="gas_m3"
                  type="number"
                  inputmode="decimal"
                  min="0"
                  step="0.01"
                  v-model.number="form.gas_m3"
                  :disabled="busy || !venue_id"
                />

                <label class="active" for="gas_m3"> Gas (m³) </label>
              </div>

              <div class="input-field col s12 m4">
                <input
                  id="water"
                  type="number"
                  inputmode="decimal"
                  min="0"
                  step="0.01"
                  v-model.number="form.water"
                  :disabled="busy || !venue_id"
                />

                <label class="active" for="water"> Water </label>
              </div>

              <div class="col s12 m4 right-align" style="margin-top: 18px">
                <button
                  class="btn blue-grey darken-2"
                  :disabled="busy || !venue_id"
                  @click="submitToday"
                >
                  Submit today
                </button>
              </div>
            </div>

            <div class="row" style="margin-bottom: 0">
              <div class="input-field col s12 m4">
                <input
                  id="elec_morning"
                  type="number"
                  inputmode="decimal"
                  min="0"
                  step="0.01"
                  v-model.number="form.electric_kwh_morning"
                  :disabled="busy || !venue_id"
                />

                <label class="active" for="elec_morning">
                  Electric (kWh) · Morning
                </label>
              </div>

              <div class="input-field col s12 m4">
                <input
                  id="elec_afternoon"
                  type="number"
                  inputmode="decimal"
                  min="0"
                  step="0.01"
                  v-model.number="form.electric_kwh_afternoon"
                  :disabled="busy || !venue_id"
                />

                <label class="active" for="elec_afternoon">
                  Electric (kWh) · Afternoon
                </label>
              </div>

              <div class="input-field col s12 m4">
                <input
                  id="elec_evening"
                  type="number"
                  inputmode="decimal"
                  min="0"
                  step="0.01"
                  v-model.number="form.electric_kwh_evening"
                  :disabled="busy || !venue_id"
                />

                <label class="active" for="elec_evening">
                  Electric (kWh) · Evening
                </label>
              </div>
            </div>

            <div
              v-if="!venue_id"
              class="card-panel amber lighten-5 amber-text text-darken-4"
              style="margin-top: 10px"
            >
              No venue selected. Please choose a venue.
            </div>

            <div
              v-if="info"
              class="card-panel blue-grey lighten-5 blue-grey-text text-darken-4"
              style="margin-top: 10px"
            >
              {{ info }}
            </div>

            <div
              v-if="error"
              class="card-panel red lighten-5 red-text text-darken-3"
              style="margin-top: 10px"
            >
              {{ error }}
            </div>

            <div class="row" style="margin-top: 10px">
              <div class="col s12">
                <div class="table-wrap">
                  <table class="highlight responsive-table">
                    <thead>
                      <tr>
                        <th style="min-width: 170px"></th>

                        <th v-for="d in days" :key="'h-' + d.key" class="center-align">
                          {{ d.label }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          <strong> Gas m³ </strong>
                        </td>

                        <td v-for="d in days" :key="'gas-' + d.key" class="center-align">
                          {{ fmt(week.gas_m3[d.key]) }}
                        </td>
                      </tr>

                      <tr class="subtitle-row">
                        <td>
                          <strong> Electric </strong>
                        </td>

                        <td
                          v-for="d in days"
                          :key="'es-' + d.key"
                          class="center-align grey-text text-darken-1"
                        >
                          —
                        </td>
                      </tr>

                      <tr>
                        <td class="indent">Morning</td>

                        <td v-for="d in days" :key="'em-' + d.key" class="center-align">
                          {{ fmt(week.electric_morning[d.key]) }}
                        </td>
                      </tr>

                      <tr>
                        <td class="indent">Afternoon</td>

                        <td v-for="d in days" :key="'ea-' + d.key" class="center-align">
                          {{ fmt(week.electric_afternoon[d.key]) }}
                        </td>
                      </tr>

                      <tr>
                        <td class="indent">Evening</td>

                        <td v-for="d in days" :key="'ee-' + d.key" class="center-align">
                          {{ fmt(week.electric_evening[d.key]) }}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <strong> Water </strong>
                        </td>

                        <td v-for="d in days" :key="'w-' + d.key" class="center-align">
                          {{ fmt(week.water[d.key]) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  class="grey-text text-darken-1"
                  style="font-size: 12px; margin-top: 8px"
                >
                  Table loads from Firestore for the current week (Mon–Sun).
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  utilitiesDayInsert,
  utilitiesWeekGet,
} from "@/scripts/sqlApiHelper/utilitiesApi";

import { weekdayKeyFromISO } from "@/scripts/sharedHelpers/formatter";

export default {
  name: "UtilitiesView",

  data() {
    return {
      busy: false,
      error: null,
      info: null,

      venue_id: "",
      venue_name: "",
      venue_postcode: "",

      days: [
        {
          key: "mon",
          label: "Monday",
        },
        {
          key: "tue",
          label: "Tuesday",
        },
        {
          key: "wed",
          label: "Wednesday",
        },
        {
          key: "thu",
          label: "Thursday",
        },
        {
          key: "fri",
          label: "Friday",
        },
        {
          key: "sat",
          label: "Saturday",
        },
        {
          key: "sun",
          label: "Sunday",
        },
      ],

      form: {
        gas_m3: null,
        electric_kwh_morning: null,
        electric_kwh_afternoon: null,
        electric_kwh_evening: null,
        water: null,
      },

      week: {
        gas_m3: {
          mon: null,
          tue: null,
          wed: null,
          thu: null,
          fri: null,
          sat: null,
          sun: null,
        },

        electric_morning: {
          mon: null,
          tue: null,
          wed: null,
          thu: null,
          fri: null,
          sat: null,
          sun: null,
        },

        electric_afternoon: {
          mon: null,
          tue: null,
          wed: null,
          thu: null,
          fri: null,
          sat: null,
          sun: null,
        },

        electric_evening: {
          mon: null,
          tue: null,
          wed: null,
          thu: null,
          fri: null,
          sat: null,
          sun: null,
        },

        water: {
          mon: null,
          tue: null,
          wed: null,
          thu: null,
          fri: null,
          sat: null,
          sun: null,
        },
      },

      __venuePoll: null,
    };
  },

  computed: {
    venueNameDisplay() {
      return this.venue_name || this.venue_id || "—";
    },
  },

  async mounted() {
    this.syncVenueFromLocalStorage(true);

    if (this.venue_id) {
      await this.loadWeek();
    }

    this.__venuePoll = setInterval(async () => {
      const changed = this.syncVenueFromLocalStorage(false);

      if (changed) {
        await this.loadWeek();
      }
    }, 500);
  },

  beforeUnmount() {
    if (this.__venuePoll) {
      clearInterval(this.__venuePoll);
    }
  },

  methods: {
    syncVenueFromLocalStorage(log) {
      const snapshotKeys = [
        "venueSnapshot",
        "coredeck_venueSnapshot",
        "coredeck_venue_snapshot",
        "venue_snapshot",
      ];

      let snapshot = {};

      for (const key of snapshotKeys) {
        try {
          const raw = localStorage.getItem(key);

          if (raw) {
            const parsed = JSON.parse(raw);

            if (parsed && typeof parsed === "object") {
              snapshot = parsed;

              break;
            }
          }
        } catch {
          // ignore invalid localStorage JSON
        }
      }

      const nextVenue = String(
        snapshot.venue_id ||
          snapshot.venueId ||
          snapshot.id ||
          localStorage.getItem("coredeck_venue") ||
          localStorage.getItem("venue") ||
          ""
      ).trim();

      const nextName = String(
        snapshot.venue_name ||
          snapshot.venueName ||
          snapshot.name ||
          snapshot.displayName ||
          localStorage.getItem("coredeck_venue_name") ||
          localStorage.getItem("venue_name") ||
          ""
      ).trim();

      const nextPostcode = String(
        snapshot.Postcode ||
          snapshot.postcode ||
          snapshot.post_code ||
          snapshot.postCode ||
          snapshot["Post code"] ||
          snapshot.coreInformation?.Postcode ||
          snapshot.coreInformation?.postcode ||
          snapshot.core_information?.Postcode ||
          snapshot.core_information?.postcode ||
          localStorage.getItem("coredeck_venue_postcode") ||
          localStorage.getItem("venue_postcode") ||
          ""
      ).trim();

      const changed = nextVenue && nextVenue !== this.venue_id;

      if (changed) {
        this.venue_id = nextVenue;

        this.venue_name = nextName;

        this.venue_postcode = nextPostcode;
      } else {
        if (nextName && nextName !== this.venue_name) {
          this.venue_name = nextName;
        }

        if (nextPostcode && nextPostcode !== this.venue_postcode) {
          this.venue_postcode = nextPostcode;
        }

        if (!this.venue_id) {
          this.venue_id = nextVenue;
        }
      }

      return changed;
    },

    clearForm() {
      this.form.gas_m3 = null;

      this.form.electric_kwh_morning = null;

      this.form.electric_kwh_afternoon = null;

      this.form.electric_kwh_evening = null;

      this.form.water = null;
    },

    clearWeek() {
      for (const k of ["mon", "tue", "wed", "thu", "fri", "sat", "sun"]) {
        this.week.gas_m3[k] = null;

        this.week.electric_morning[k] = null;

        this.week.electric_afternoon[k] = null;

        this.week.electric_evening[k] = null;

        this.week.water[k] = null;
      }
    },

    buildPayloadFromForm() {
      const payload = {};

      const addIfProvided = (key, val) => {
        const n = Number(val);

        if (Number.isFinite(n) && n > 0) {
          payload[key] = n;
        }
      };

      addIfProvided("gas_m3", this.form.gas_m3);

      addIfProvided("water", this.form.water);

      addIfProvided("electric_kwh_morning", this.form.electric_kwh_morning);

      addIfProvided("electric_kwh_afternoon", this.form.electric_kwh_afternoon);

      addIfProvided("electric_kwh_evening", this.form.electric_kwh_evening);

      return payload;
    },

    async loadWeek() {
      this.error = null;
      this.info = null;

      if (!this.venue_id) {
        this.clearWeek();
        return;
      }

      this.busy = true;

      try {
        const res = await utilitiesWeekGet({
          venue_id: this.venue_id,
        });

        if (!res?.ok) {
          throw new Error(res?.error || "Failed to load utilities week");
        }

        this.applyRowsToWeek(res.rows || []);
      } catch (e) {
        this.error = e?.message || String(e);
      } finally {
        this.busy = false;
      }
    },

    applyRowsToWeek(rows) {
      this.clearWeek();

      for (const r of rows) {
        const key = weekdayKeyFromISO(r.trading_date);

        if (!key) {
          continue;
        }

        this.week.gas_m3[key] = r.gas_m3 ?? null;

        this.week.electric_morning[key] = r.electric_kwh_morning ?? null;

        this.week.electric_afternoon[key] = r.electric_kwh_afternoon ?? null;

        this.week.electric_evening[key] = r.electric_kwh_evening ?? null;

        this.week.water[key] = r.water ?? null;
      }
    },

    async submitToday() {
      this.error = null;
      this.info = null;

      this.syncVenueFromLocalStorage(false);

      if (!this.venue_id) {
        this.error = "No venue selected.";

        return;
      }

      const payload = this.buildPayloadFromForm();

      this.busy = true;

      try {
        const res = await utilitiesDayInsert({
          venue_id: this.venue_id,

          venue_name: this.venueNameDisplay,

          postcode: this.venue_postcode,

          payload,
        });

        if (!res?.ok) {
          throw new Error(res?.error || "Failed to submit utilities");
        }

        if (!res.changed) {
          this.info = "No values provided.";

          await this.loadWeek();

          return;
        }

        if (res.emailSent) {
          this.info = "Saved for today and test email sent.";
        } else {
          this.info = "Saved for today.";

          this.error = `Saved to database, but the email failed: ${
            res.emailError || "Unknown email error"
          }`;
        }

        this.clearForm();

        await this.loadWeek();
      } catch (e) {
        this.error = e?.message || String(e);
      } finally {
        this.busy = false;
      }
    },

    fmt(v) {
      if (v === null || v === undefined || v === "") {
        return "—";
      }

      const n = Number(v);

      if (!Number.isFinite(n)) {
        return "—";
      }

      return n % 1 === 0 ? String(n) : n.toFixed(2);
    },
  },
};
</script>

<style scoped>
.subtitle-row td {
  background: #f5f5f5;
}

.indent {
  padding-left: 18px;
  color: rgba(0, 0, 0, 0.7);
}
</style>
